import { Box, Typography } from '@mui/material';
import { muiStyles } from './muiStyles';

const NoDeals = () => {
  return (
    <Box sx={muiStyles.root}>
      <Typography>No deals found</Typography>
    </Box>
  );
};

export default NoDeals;
